import * as React from 'react';

import { AddressDetailField } from '@shared/types/address_detail';
import { APARTMENT_BUILDING_SUBTYPE_OPTIONS } from '@shared/types/address_detail';
import { IAddressDetail } from '@shared/types/address_detail';
import { IAddressValidationErrors } from '@shared/types/address_detail';

import { Restrictions } from '@portal/components/addresses/form/buildings/restrictions';

import { Access } from './access';
import { AdditionalNotes } from './additional_notes';
import { BuildingFloor } from './building_floor';
import { GatedCommunity } from './gated_community';
import { LongCarry } from './long_carry';
import { SquareFeet } from './square_feet';
import { Subtype } from './subtype';

export const Apartment: React.FC<{
  details: IAddressDetail;
  errors?: IAddressValidationErrors;
  setDetails(details: IAddressDetail): void;
}> = ({ details, errors, setDetails }) => (
  <>
    <Subtype
      value={details.buildingSubtype}
      label="What type of apartment building?"
      options={APARTMENT_BUILDING_SUBTYPE_OPTIONS}
      error={errors?.[AddressDetailField.BuildingSubtype]}
      onChange={(value) => setDetails({ ...details, [AddressDetailField.BuildingSubtype]: value })}
    />
    <BuildingFloor
      details={details}
      error={errors?.[AddressDetailField.Floor]}
      onChange={(value) => setDetails({ ...details, [AddressDetailField.Floor]: value })}
    />
    <SquareFeet
      value={details[AddressDetailField.SquareFeet]}
      onChange={(value) => setDetails({ ...details, [AddressDetailField.SquareFeet]: value })}
    />
    <Access details={details} error={errors?.access} onChange={(values) => setDetails({ ...details, ...values })} />
    <LongCarry
      value={details[AddressDetailField.LongCarry]}
      onChange={(value) => setDetails({ ...details, [AddressDetailField.LongCarry]: value })}
    />
    <GatedCommunity
      value={details[AddressDetailField.Gated]}
      onChange={(value) => setDetails({ ...details, [AddressDetailField.Gated]: value })}
    />
    <Restrictions
      details={details}
      onDetail={setDetails}
      error={errors?.[AddressDetailField.BuildingRestrictionsAnswer]}
      initialBuildingRestrictionsAnswer={details[AddressDetailField.BuildingRestrictionsAnswer]}
    />
    <AdditionalNotes
      value={details[AddressDetailField.AdditionalNotes]}
      onChange={(value) => setDetails({ ...details, [AddressDetailField.AdditionalNotes]: value })}
    />
  </>
);
